import { render, staticRenderFns } from "./EditVideoCodecsForm.vue?vue&type=template&id=30d2082c&scoped=true&"
import script from "./EditVideoCodecsForm.vue?vue&type=script&lang=js&"
export * from "./EditVideoCodecsForm.vue?vue&type=script&lang=js&"
import style0 from "./EditVideoCodecsForm.vue?vue&type=style&index=0&id=30d2082c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d2082c",
  null
  
)

export default component.exports